const filterQueries = (allowlist = [], queries = {}) =>
    allowlist.reduce((acc, param) => {
        const validQuery = queries[param];
        return { ...acc, ...(validQuery && { [param]: validQuery }) };
    }, {});

export default filterQueries;
